<ng-container *transloco="let t; prefix: 'notificationBell'">
  @if (data.RedirectUrl) {
    <a
      type="button"
      [href]="data.RedirectUrl"
      [class]="'notification ' + containerClass"
      [class.new]="notification.userNotificationStatus === 'New'"
      target="_blank"
    >
      <ng-container *ngTemplateOutlet="message" />
    </a>
  }

  @if (!data.RedirectUrl) {
    <div class="notification" [class.new]="notification.userNotificationStatus === 'New'">
      <ng-container *ngTemplateOutlet="message" />
    </div>
  }

  <ng-template #message>
    <div class="content">
      @if (data.Subject) {
        <p>
          <b>{{ data.Subject }}</b>
        </p>
      }
      @if (data.PreviewText) {
        <p>{{ data.PreviewText }}</p>
      }
      <p>
        <span class="time">{{ notification.notificationTime | timeToNow }} {{ notification.notificationTime ? ' ago' : '' }}</span>
        @if (data.RedirectUrl && data.CallToActionText) {
          <span>&bull;</span>
          <a [href]="data.RedirectUrl" mat-button target="_blank" color="primary">{{ data.CallToActionText }}</a>
        }
      </p>
    </div>

    <img alt="" class="confetti" [src]="'notification-bell/confetti.svg' | staticImageUrl" />
  </ng-template>
</ng-container>
